export default `
    ... on ds_AlertBar_GlobalSet {
        id
        name
        alertBar_ColorTheme
        alertBar_ColorPalette
        alertBar_Alignment
        alertBar_Items {
            ... on ds_AlertBarItem_Entry {
                canonicalUid
                id
                alertBarItem_Text
                alertBarItem_Link {
                    url
                    target
                    text
                }
                alertBarItem_Icon {
                    type
                    set
                    name
                }
            }
        }
    }
`